import { Observable } from 'rxjs';

export function toPromise<T>(obs: Observable<T>): Promise<T> {
  return new Promise((resolve, reject) => {
    obs.subscribe(
      (value) => resolve(value),
      (error) => reject(error)
    );
  });
}
